import { render, staticRenderFns } from "./RootDialog.vue?vue&type=template&id=a9606870&scoped=true&"
import script from "./RootDialog.vue?vue&type=script&lang=js&"
export * from "./RootDialog.vue?vue&type=script&lang=js&"
import style0 from "./RootDialog.vue?vue&type=style&index=0&id=a9606870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9606870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
